import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SharedGuardService } from "./shared-guard.service";
import { filter, firstValueFrom } from "rxjs";
import { SubscriptionService } from "../subscription/subscription.service";
import { ConsumptionPlan } from "@libs/shares/models/subscription.model";
import { SubscriptionTopUpService } from "../subscription/top-up.service";

export const kycGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const sharedGuardService = inject(SharedGuardService);
  const subscriptionService = inject(SubscriptionService);
  const topUpSubscriptionService = inject(SubscriptionTopUpService);
  const user = await sharedGuardService.hasUser();

  if (!user) {
    return router.parseUrl("/login");
  }

  const requiresVerification = await sharedGuardService.requiresVerification();

  if (requiresVerification) {
    return true;
  } else if ((await firstValueFrom(sharedGuardService.organization)).isSuspended) {
    return router.parseUrl("/suspended-account");
  }

  const activeSub = await firstValueFrom(sharedGuardService.activeSubscription.pipe(filter((sub) => !!sub)));
  const pendingSubscription = subscriptionService.pendingSubscription();

  const queryParams = route.queryParams;
  if (activeSub) {
    const pendingTopUp = await topUpSubscriptionService.getPendingTopUp(activeSub.id);
    if (pendingTopUp) {
      return router.createUrlTree(["/topup-plan"], { queryParams });
    }
  }
  if (pendingSubscription) {
    if (pendingSubscription.plan === ConsumptionPlan.custom) {
      return router.createUrlTree(["/plan-configuration"], { queryParams });
    }
    return router.createUrlTree(["/change-plan"], { queryParams });
  }

  return router.parseUrl("/profile-setup");
};
